<template>
  <el-row type="flex" justify="space-between" class="date-picker">
    <el-col :span="4" class="text-center">
      <el-button @click="$emit('timeSwitchButtonTrigger','timeDes')" type="text"><img src="@/assets/images/previous.svg" alt=""></el-button>
    </el-col>
    <el-col :span="16" class="text-center">
      <span>{{ startAt }} ～ {{ endAt }}</span>
    </el-col>
    <el-col :span="4" class="text-center">
      <el-button @click="doNext" type="text" :disabled="canNext === false" ><img src="@/assets/images/next.svg" alt=""></el-button>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "DatePicker",
  props: ['startAt', 'endAt','canNext'],
  data() {
    return {}
  },
  created() {

  },
  mounted() {

  },
  methods: {
    doNext() {
      if(this.canNext === true ) {
        this.$emit('timeSwitchButtonTrigger','timeAdd')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.date-picker {
  padding: 10px;
  height: 60px;
  width: 100%;
  background: #fff;
  @media(min-width: 1024px){
    max-width: 400px;
    margin: 0 auto;
  }
  button {
    padding: 0;
    width: 38px;
    &[disabled="disabled"]{
      opacity: .3;
    }
  }
}
</style>